import { createTheme } from '@mui/material/styles';

import MuiAutocomplete from '../../style-overrides/MuiAutocomplete';
import MuiButton from '../../style-overrides/MuiButton';
import MuiCheckbox from '../../style-overrides/MuiCheckbox';
import MuiDivider from '../../style-overrides/MuiDivider';
import MuiFormControlLabel from '../../style-overrides/MuiFormControlLabel';
import MuiFormHelperText from '../../style-overrides/MuiFormHelperText';
import MuiInputBase from '../../style-overrides/MuiInputBase';
import MuiInputLabel from '../../style-overrides/MuiInputLabel';
import MuiListItemButton from '../../style-overrides/MuiListItemButton';
import MuiLoadingButton from '../../style-overrides/MuiLoadingButton';
import MuiMenuItem from '../../style-overrides/MuiMenuItem';
import MuiOutlinedInput from '../../style-overrides/MuiOutlinedInput';
import MuiRadio from '../../style-overrides/MuiRadio';
import MuiSkeleton from '../../style-overrides/MuiSkeleton';
import MuiSvgIcon from '../../style-overrides/MuiSvgIcon';
import MuiSwitch from '../../style-overrides/MuiSwitch';
import MuiToggleButton from '../../style-overrides/MuiToggleButton';
import MuiTooltip from '../../style-overrides/MuiTooltip';
import { BREAKPOINTS, COLORS, newLayout } from '../../theme';
import {
  BUTTON_STYLE,
  INPUT_OUTLINED_STYLE,
  TEXTFIELD_OUTLINE_STYLE,
} from '../../utils/constants';

export const lightTheme = createTheme({
  typography: {
    fontFamily: ['urw-form', 'sans-serif'].join(','),
  },
  components: {
    MuiButton: BUTTON_STYLE,
    MuiOutlinedInput: INPUT_OUTLINED_STYLE,
    MuiSelect: TEXTFIELD_OUTLINE_STYLE,
    MuiTextField: TEXTFIELD_OUTLINE_STYLE,
  },
});

export const newLayoutTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: BREAKPOINTS.tablet[0],
      md: BREAKPOINTS.desktopSmall[0],
      lg: BREAKPOINTS.desktopMedium[0],
      xl: BREAKPOINTS.desktopLarge[0],
    },
  },
  palette: {
    primary: {
      main: COLORS.kinetikBlue,
      light: COLORS.blueLight,
      dark: COLORS.blueDark,
      contrastText: COLORS.white,
    },
  },
  typography: {
    fontFamily: newLayout.fontFamily.primary,
    h1: {
      fontSize: newLayout.fontSize.h1,
      lineHeight: newLayout.lineHeight.h1,
    },
    h2: {
      fontSize: newLayout.fontSize.h2,
      lineHeight: newLayout.lineHeight.h2,
    },
    h3: {
      fontSize: newLayout.fontSize.h3,
      lineHeight: newLayout.lineHeight.h3,
    },
    h4: {
      fontSize: newLayout.fontSize.h4,
      lineHeight: newLayout.lineHeight.h4,
    },
    h5: {
      fontSize: newLayout.fontSize.h5,
      lineHeight: newLayout.lineHeight.h5,
    },
    h6: {
      fontSize: newLayout.fontSize.h6,
      lineHeight: newLayout.lineHeight.h6,
    },
    body1: {
      fontSize: newLayout.fontSize.body2,
      lineHeight: newLayout.lineHeight.body2,
    },
    body2: {
      fontSize: newLayout.fontSize.body2,
      lineHeight: newLayout.lineHeight.body2,
    },
    body3: {
      fontFamily: newLayout.fontFamily.primary,
      fontSize: newLayout.fontSize.body3,
      lineHeight: newLayout.lineHeight.body3,
    },
    body4: {
      fontFamily: newLayout.fontFamily.primary,
      fontSize: newLayout.fontSize.body4,
      lineHeight: newLayout.lineHeight.body4,
    },
  },
  components: {
    MuiAutocomplete,
    MuiButton,
    MuiCheckbox,
    MuiDivider,
    MuiFormControlLabel,
    MuiFormHelperText,
    MuiListItemButton,
    MuiLoadingButton,
    MuiOutlinedInput,
    MuiMenuItem,
    MuiRadio,
    MuiSkeleton,
    MuiSwitch,
    MuiToggleButton,
    MuiTooltip,
    MuiInputBase,
    MuiInputLabel,
    MuiSvgIcon,
  },
});
